<template>
    <!-- Phase 3 (feedback phase) will show components based on state.progress value. -->
    <div class="container">
        <div v-if="state.progress===0">
            <h2 class ="unselectable">Kiitos keskustelusta!</h2>
            <h4 class ="unselectable">Jokainen Trigenda® työskentely  päättyy palautteeseen. Pääset antamaan palautetta käydystä keskustelusta; sen herättämistä ajatuksista ja oivalluksista.
            Seuraavaksi saat valita 2-3 käsitekorttia, jotka kuvaavat mielestäsi parhaiten käytyä keskustelua.
            <br class ="unselectable">Valitsethan seuraavaksi 2-3 korttia, jotka mielestäsi kuvaavat käytyä keskustelua.</h4>
            <button @click="() => state.progress++">Jatka eteenpäin</button>
        </div>
        <FeedbackCards
            v-if="state.progress===1"
            class="paddingTop"
            title="Valitse 2-3 korttia, jotka mielestäsi kuvaavat käytyä keskustelua."
            @goBack="goBack"
            @nextProgress="checkChosenCount" />
        <Answer
            v-if="state.progress===2"
            class="paddingTop"
            :title="'Miksi valitsit kortin ' + state.answerToCard.description + '?'"
            :cardTitle="state.answerToCard.description"
            :card="state.answerToCard"
            @answer="saveAnswer"
            @goBack="goBack" />
        <Answer
            v-if="state.progress===3"
            class="paddingTop"
            :title="'Miksi valitsit kortin ' + state.answerToCard.description + '?'"
            :cardTitle="state.answerToCard.description"
            :card="state.answerToCard"
            @answer="saveAnswer"
            @goBack="goBack" />
        <Answer
            v-if="state.progress===4"
            class="paddingTop"
            :title="'Miksi valitsit kortin ' + state.answerToCard.description + '?'"
            :cardTitle="state.answerToCard.description"
            :card="state.answerToCard"
            @answer="saveAnswer"
            @goBack="goBack" />
        <SavePDF v-if="state.progress===5" />
    </div>
</template>

<script>
import Summary from './Summary.vue';
import FeedbackCards from './FeedbackCards.vue';
import Answer from './Answer.vue';
import { reactive } from 'vue';
import SavePDF from './SavePDF.vue';

export default {
    name: 'Phase3',
    components: {
        FeedbackCards,
        Answer,
        Summary,
        SavePDF
    },
    setup(props, { emit }) {

        /**
         * State object contains the progress (which component to show) of Phase 3.
         * history saves the changes made during Phase 3: modifiedCardIndex (which card was modified)
         * and modifiedProperty tells which property of the card was modified.
         * answerToCard is passed to Answer component as a prop and tells which card the answer will
         * be saved to.
         */
        const state = reactive({
            progress: 0,
            history: [],
            answerToCard: null
        });

        const goBack = () => {
            state.progress--;

            /**
             * If current progress is FeedBackCards component after going back,
             * do nothing.
             * Otherwise check history arrays object based on current progress.
             * If the object has info of modifiedCardIndex and modifiedProperty is answer,
             * delete answer property, because answer must me undone.
             */
            if (state.progress === 1)
                return;
            else if (typeof state.history[state.progress].modifiedCardIndex !== 'undefined' && state.history[state.progress].modifiedProperty === 'answer') {
                const feedbackCards = JSON.parse(localStorage.getItem('feedbackCards'));
                delete feedbackCards[state.history[state.progress].modifiedCardIndex].answer;
                localStorage.setItem('feedbackCards', JSON.stringify(feedbackCards));
                setAnswerToCard();
            }
        }

        const saveAnswer = (card, answer) => {

            /**
             * Find which card should be the answer saved to based on the
             * id of the card given as parameter from Answer component.
             * Save the answer given as paremeter and save feedbackCards back
             * to localStorage.
             */
            const feedbackCards = JSON.parse(localStorage.getItem('feedbackCards'));
            const cardToModifyIndex = feedbackCards.findIndex(cardInArray => cardInArray.id === card.id);

            feedbackCards[cardToModifyIndex].answer = answer;
            localStorage.setItem('feedbackCards', JSON.stringify(feedbackCards));

            /**
             * Save modification history. It contains index of the modified card and
             * type of modifiedProperty 'answer'. History is needed if the user
             * wants to go back in progress and modified properties needs to be
             * deleted from the card.
             */
            const saveHistoryData = { modifiedCardIndex: card.id, modifiedProperty: 'answer' };
            state.history[state.progress] = saveHistoryData;
            state.answerToCard = null;
            gotoNextAnswer();
        }

        const checkChosenCount = () => {

            /**
             * Check how many FeedbackCards are selected based on
             * card.chosen property
             */
            let chosenCardsCount = 0;
            const feedbackCards = JSON.parse(localStorage.getItem('feedbackCards'));

            feedbackCards.forEach(card => {
                if (card.chosen)
                    chosenCardsCount++;
            });

            if (chosenCardsCount > 1)
                gotoNextAnswer();
        }

        const gotoNextAnswer = () => {

            setAnswerToCard();

            /**
             * If there is no state.answerToCard value set,
             * finish the phase (progress 5).
             * Otherwise increase progress
             */
            if (!state.answerToCard)
                state.progress = 5;
            else
                state.progress++;

        }

        const setAnswerToCard = () => {

            /**
             * This function sets the card to be answered by the Answer component.
             * It finds next card in feedbackCards which was chosen in the FeedbackCards
             * stage and doesn't have an answer property yet.
             */
            const feedbackCards = JSON.parse(localStorage.getItem('feedbackCards'));

            state.answerToCard = feedbackCards.find(card => {
                if (card.chosen && typeof card.answer === 'undefined')
                    return card;
            });
        }

        const restartFromBeginning = () => {
            localStorage.removeItem('cardArray');
            localStorage.removeItem('feedbackCards');
            emit('restartFromBeginning');
        }

        const restartFromPhaseTwo = () => {
            localStorage.removeItem('feedbackCards');
            const cardArray = JSON.parse(localStorage.getItem('cardArray'));

            cardArray.forEach(card => {
                if (typeof card.phase2selection !== 'undefined')
                    delete card.phase2selection;
                if (typeof card.answer !== 'undefined')
                    delete card.answer;
            });

            localStorage.setItem('cardArray', JSON.stringify(cardArray));

            emit('restartFromPhaseTwo');
        }

        const goToForms = () => {
            window.location = 'https://docs.google.com/forms/d/e/1FAIpQLSd6f_TYtuLMLXUoUwj84LPRga-Lyo5XPyMBKfyZ_ozCIIZIuw/viewform';
        }

        return {
            state,
            goBack,
            saveAnswer,
            gotoNextAnswer,
            checkChosenCount,
            restartFromBeginning,
            restartFromPhaseTwo,
            goToForms,
        };
    },
    emits: ['restartFromBeginning', 'restartFromPhaseTwo'],
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h2 {
    margin-top: 10vh;
}
h3 {
    margin: 40px 0 0;
}

h4 {
    margin-left: 25%;
    margin-right: 25%;
}

ul {
    list-style-type: none;
    padding: 0;
}

.unselectable {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
}

li {
    /*display: inline-block;*/
}

a {
    color: var(--link_color);
}

.paddingTop {
    padding-top: 1.5em;
}
@media only screen and (max-width: 1200px) {
    h4 {
        margin-left: 12%;
        margin-right: 12%;
    }
}
@media only screen and (max-width: 500px) {
    h4 {
        margin-left: 4%;
        margin-right: 4%;
    }
}
</style>
